import { type FunctionalComponent, h } from "preact";
import type { PageCounters } from "../article-list-container";
import type { ArticleModel } from "../magazine.service";
import { ArticleCard } from "./article-card";
import { useEffect } from "preact/hooks";

export interface MagazineArticleProps {
  articles: ArticleModel[];
  pageCounters: PageCounters;
  onClickHandler: (e: Event, page: number) => Promise<void>;
}

export const MagazineArticle: FunctionalComponent<MagazineArticleProps> = ({
  articles,
  pageCounters,
  onClickHandler,
}: MagazineArticleProps) => {
  if (!articles || articles.length === 0) return null;

  // if the url ends with /emne or /emne/ we need to remove the ending url part
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;

    if (/\/emne\/?$/.test(url)) {
      let newUrl = url.replace(/\/emne(\/)?(?!([a-zA-Z0-9]))$/, "");
      newUrl = newUrl.endsWith("/") ? newUrl : `${newUrl}/`;
      if (window.location.search) {
        newUrl = `${newUrl}${window.location.search}`;
      }
      history.replaceState(null, "", newUrl);
    } else if (!url.endsWith("/")) {
      let newUrl = `${url}/`;
      if (window.location.search) {
        newUrl = `${newUrl}${window.location.search}`;
      }
      history.replaceState(null, "", newUrl);
    }
  }, []);

  return (
    <div className="area-l">
      <div className="magazine ">
        {articles.map((article, index) =>
          ArticleCard({ article, context: "Magazine", showIngress: false, lazyLoadImage: index > 0 }),
        )}
      </div>
      {pageCounters.hasMoreArticles ? (
        <button
          className="magazine-more-articles btn btn--small btn--primary btn--center"
          type="button"
          onClick={(e: Event): Promise<void> => onClickHandler(e, pageCounters.nextPageNr)}
        >
          Last flere
        </button>
      ) : (
        <div className="magazine-nomore-articles" />
      )}
    </div>
  );
};
